import React from "react"
import styled from "styled-components"

const FeaturedArticle = () => {
  return <Container>Nog te bouwen: Featured Article</Container>
}

const Container = styled.section`
  width: 60vw;
  height: 30vw;
  background-color: var(--dark-card);
  color: var(--text-gray);
  border-radius: 30px;
  padding: 30px;
  margin: 20px;
`

export default FeaturedArticle
